import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { CourseResourceListComponent } from '@components/pages';

function CourseResourceManagement() {
  const { setPageName } = useOutletContext();

  useEffect(() => {
    setPageName('Recursos de curso');
  }, []);

  return (
    <div className="card">
      <CourseResourceListComponent />
    </div>
  );
}

export default CourseResourceManagement;
